__turbopack_context__.v({
  "actionGroup": "RemindMe-module-scss-module__dJ68VW__actionGroup",
  "buttonRow": "RemindMe-module-scss-module__dJ68VW__buttonRow",
  "consentLabel": "RemindMe-module-scss-module__dJ68VW__consentLabel",
  "consentRow": "RemindMe-module-scss-module__dJ68VW__consentRow",
  "organizerInfoSection": "RemindMe-module-scss-module__dJ68VW__organizerInfoSection",
  "remindMeIcon": "RemindMe-module-scss-module__dJ68VW__remindMeIcon",
  "remindMeModalContent": "RemindMe-module-scss-module__dJ68VW__remindMeModalContent",
  "reminderSetButtonVariant": "RemindMe-module-scss-module__dJ68VW__reminderSetButtonVariant",
  "reminderSetDescription": "RemindMe-module-scss-module__dJ68VW__reminderSetDescription",
  "reminderSetTitle": "RemindMe-module-scss-module__dJ68VW__reminderSetTitle",
});
